<!-- IMMAGINE DI TESTATA -->
<section class="masthead-articles"></section>

<!-- NAVIGAZIONE -->
<section class="textblock wrapper marginauto montserrat">
    <div class="row">
        <div class="col-11 pt-5 pb-4">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a href="/">
                            <i class="fa fa-home" aria-hidden="true"></i> Home
                        </a>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="/in-evidenza">
                            In Evidenza
                        </a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <span *ngIf="$blogPostMetadata | async as blogPost">
                            {{ blogPost.pageTitle }}
                        </span>
                    </li>
                </ol>
            </nav>
        </div>
    </div>
</section>

<!-- INFO ARTICOLO -->
<section class="grey mb-5 montserrat">
    <div class="textblock wrapper marginauto">
        <div class="col-11 marginauto py-5">
            <div class="text title pb-2">
                <span class="text-uppercase" *ngIf="$blogPostMetadata | async as blogPost">
                    {{ blogPost.pageTitle }}
                </span>
            </div>
            <span *ngIf="$blogPostMetadata | async as blogPost" class="mb-5 badge badge-pill badge-secondary">
                #{{ blogPost.hash }}
            </span>
        </div>
    </div>
</section>

<scully-content></scully-content>
